// @flow

import { locale } from 'moment';

locale('de');
